import { render, staticRenderFns } from "./UnknownPage.vue?vue&type=template&id=2872cfc6"
import script from "./UnknownPage.vue?vue&type=script&lang=ts"
export * from "./UnknownPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports